import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	iconAltText: {
		id: 'fabric.editor.ai.ai-panels.screens.loading.iconAltText',
		defaultMessage: 'Generating icon',
		description: 'Icon alt text of the Loading screen',
	},
});
